import { MDBBtn } from "mdb-react-ui-kit";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const SaveChanges = (props) => {
  const { t, i18n } = useTranslation();
  const [pickedLanguage, setPickedLanguage] = useState("united-kingdom");

  return (
    <>
      <div className="footer btnControls z-index_value">
        <MDBBtn color="secondary" onClick={(e) => props.onClose(e)}>
          {t("cancel")}
        </MDBBtn>
        <MDBBtn onClick={props.onSave} color="dark" className="ml-3">
          {t("saveChanges")}
        </MDBBtn>
      </div>
    </>
  );

};

export default SaveChanges;